import React from 'react';
import { useSelector } from 'react-redux';

import SelectedParameter from './SelectedParameter';

import { getSelectedParameters } from 'store';

const SelectedParametersListComponent = () => {
  const selectedParameters = useSelector(state => getSelectedParameters(state));

  return (
    <div>
      {Object.values(selectedParameters).map(parameter => (
        <SelectedParameter key={parameter.name} {...parameter} />
      ))}
    </div>
  );
};

export default SelectedParametersListComponent;
